var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-fields" },
    [
      _vm.isFieldsArray
        ? _vm._l(_vm.displayedFields, function(field) {
            return _c("data-field", {
              key: field.key,
              attrs: {
                field: field,
                depth: 0,
                path: field.key,
                editable: field.editable,
                "force-collapse": _vm.forceCollapse,
                "is-state-field": _vm.isStateField(field)
              }
            })
          })
        : _vm._l(_vm.displayedFields, function(value, key) {
            return _c("data-field", {
              key: key,
              attrs: {
                field: { value: value, key: key },
                depth: 0,
                path: key,
                editable: false
              }
            })
          }),
      _vm.fieldsCount > _vm.limit
        ? _c("VueButton", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Show more",
                expression: "'Show more'"
              }
            ],
            staticClass: "icon-button flat more",
            attrs: { "icon-left": "more_horiz" },
            on: {
              click: function($event) {
                return _vm.showMore()
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }